import React from "react";
import {connect} from "react-redux";
import {sendLogError} from "../actions/LogActions";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error, info) {
        const {sendLogError} = this.props;

        this.setState({ hasError: true });

        sendLogError({
            'message': error.message,
            'stack': error.stack,
        })
    }

    render() {
        if (this.state.hasError) {
            return <div className="critical-error">
                <h4>Something went wrong.</h4>
            </div>
        }

        return this.props.children;
    }
}

export default connect(
    null,
    dispatch => ({
        sendLogError: data => dispatch(sendLogError(data)),
    })
)(ErrorBoundary)